export function getFieldsOfLabelEntityAsObject(labels, entity) {
  return labels.Label[entity]
}

export default {}
